const ALLOWED_CHARACTERS = 'abcdefghijklmnopqrstuvwxyz0123456789*#[]%()$ABCDEFGHIJKLMNOPQRST';

export const createRandomString = (passwordLength: number): string =>
  Array.from(new Array(passwordLength))
    .map(() => ALLOWED_CHARACTERS.charAt(Math.floor(Math.random() * ALLOWED_CHARACTERS.length)))
    .join('');
